let Values = {
  LEFT_FORELIMB : 'LEFT_FORELIMB',
  RIGHT_FORELIMB: 'RIGHT_FORELIMB',
  LEFT_HINDLIMB : 'LEFT_HINDLIMB',
  RIGHT_HINDLIMB: 'RIGHT_HINDLIMB',
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value) => {
    switch (value) {

      case Values.LEFT_FORELIMB:
        return "Antérieur gauche"

      case Values.RIGHT_FORELIMB:
        return "Antérieur droit"

      case Values.LEFT_HINDLIMB:
        return "Postérieur gauche"

      case Values.RIGHT_HINDLIMB:
        return "Postérieur droit"

      default:
        return value;
    }
  },

  /* Get short for value. */
  short: (value) => {
    switch (value) {

      case Values.LEFT_FORELIMB:
        return "AG"

      case Values.RIGHT_FORELIMB:
        return "AD"

      case Values.LEFT_HINDLIMB:
        return "PG"

      case Values.RIGHT_HINDLIMB:
        return "PD"

      default:
        return value;
    }
  }
});
